const phoneRegex = /^(\+|00)?\d{8,}$/;

const validate = (value: any, [locale = null] = []): boolean => {
    if (typeof value !== 'string') {
        return false;
    }

    return phoneRegex.test(value);
};

export default validate;